import wanderalley1 from "./Wanderalley.png";
import wanderalley2 from "./Wanderalley (2).png";

const Wanderalley = [wanderalley1, wanderalley2];

export default Wanderalley;
